import appConfigCoverGoUat from "./appConfigCoverGoUat.js"
import { COVERGO_SAAS_DEV } from "../consts.js"

export const omsa = {
	"omsa-uat-studio.quote.hk": { appConfig: appConfigCoverGoUat, envConfig: COVERGO_SAAS_DEV }
}
